import { Component, inject, Inject } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IReorderingDialogData, IReorderingDialogDataItem } from './interfaces';
import { TRANSLATION_MAP } from '../const';
import { SharedService } from '../shared.service';

@Component({
    selector: 'azavista3-reordering-dialog',
    templateUrl: './reordering-dialog.component.html',
    standalone: false
})
export class ReorderingDialogComponent<T extends IReorderingDialogDataItem> {
    TRANSLATION_MAP = TRANSLATION_MAP;
    private sharedSvc = inject(SharedService);

    constructor(
        public dialogRef: MatDialogRef<ReorderingDialogComponent<T>>,
        @Inject(MAT_DIALOG_DATA) public data: IReorderingDialogData<T>) {
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }

    onApplyClick(): void {
        this.dialogRef.close(this.data.items);
    }

    drop(event: CdkDragDrop<any[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }

    sortAlphabetically() {
        const itemsToSort = this.data.items.concat();
        this.sharedSvc.sortAlphabetically(itemsToSort, item => item.name);
        this.bulkReorder(itemsToSort);
    }

    reverseOrder() {
        const itemsToSort = this.data.items.concat().reverse();
        this.bulkReorder(itemsToSort);
    }

    bulkReorder(reorderedItems: T[]) {
        this.data.items.splice(0);
        this.data.items.push(...reorderedItems);
    }
}
